import { Howler, Howl } from 'howler'
import { audio } from '../config/settings'
import { isIOS, isAndroid } from '../helpers/features'
import { applyMute, setGlobalVolume, stopSoundOfType, setMutedManually } from './audioUtils'
import { initSfxMeta } from './audioState'
import {
  startMusic,
  toggleMusic,
  fadeMusicVolumeUp,
  fadeMusicVolumeDown,
  playMusic,
  playItemSfx,
  stopItemSfx,
  playSfx,
} from './soundController'

let audioStarted = false

function init(): void {
  // Force WebAudio for better volume handling on iOS (prevents fallback to HTML5 audio)
  Howler.autoUnlock = true
  Howler.usingWebAudio = true

  setGlobalVolume(audio.GLOBAL_VOLUME)
  initSfxMeta()

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      Howler.mute(true) // mute only when tab becomes hidden
    } else {
      // tab is visible → unmute only if not manually muted
      applyMute()

      // resume audio context
      Howler.ctx?.resume().catch(() => {})
    }
  })
}

function startAudio(): void {
  // Start audio only after user interaction to avoid autoplay restrictions
  // Guard against multiple calls
  if (audioStarted) return
  audioStarted = true

  // On Android/iOS, the WebAudio context must be unlocked by playing a sound
  // in direct response to user interaction. Play sounds immediately.
  // Howler.autoUnlock will handle context unlocking when the first sound plays.
  startMusic()

  // On Android/iOS, ensure context is resumed if it was suspended
  // Check after a brief delay to allow context to be created
  if (isAndroid || isIOS) {
    setTimeout(() => {
      if (Howler.ctx && Howler.ctx.state === 'suspended') {
        Howler.ctx.resume().catch(() => {})
      }
    }, 100)
  }
}

const audioManager = {
  init,
  startAudio,
  playSfx,
  playItemSfx,
  stopItemSfx,
  toggleMusic,
  fadeMusicVolumeUp,
  fadeMusicVolumeDown,
  playMusic,
  stopSoundOfType,
  setMutedManually,
}

export default audioManager
